import classNames from 'classnames'
import SkeletonLoader from '../../../core/skeletonLoader'
import {useNamespaceTranslations} from '../../../../utils/hooks/useNamespacesTranslations'

const SkeletonRow = ({isDarkMode}) => (
    <div className={classNames('ruleset-item', {dark: isDarkMode})}>
        <div className="ruleset-item-header">
            <div className="header">
                <SkeletonLoader className="ruleset-skeleton-title" />
                <SkeletonLoader className="ruleset-skeleton-badge" />
            </div>
        </div>
        <div className="ruleset-item-details">
            <div className="ruleset-info">
                <SkeletonLoader className="ruleset-skeleton-pill" />
            </div>
            <div className="ruleset-info">
                <SkeletonLoader className="ruleset-skeleton-pill" />
            </div>
            <div className="ruleset-info">
                <SkeletonLoader className="ruleset-skeleton-text" />
            </div>
            <div className="ruleset-info actions" />
        </div>
    </div>
)

const ListSkeleton = ({isDarkMode, rows = 3}) => {
    const text = useNamespaceTranslations('rulesets')

    return (
        <div className="rulesets-list-container ruleset-skeleton-list">
            <div className="rulesets-usage-details">
                <SkeletonLoader className="ruleset-skeleton-button" />
                <div className="usage-limit-chart">
                    <SkeletonLoader className="ruleset-skeleton-usage-circle" />
                    <SkeletonLoader className="ruleset-skeleton-usage-label" />
                </div>
            </div>
            <div className="ruleset-grid">
                <div className={classNames('ruleset-list', {dark: isDarkMode})}>
                    <div className={classNames('ruleset-group', {dark: isDarkMode})}>
                        <div className="ruleset-group-header">
                            <div className="ruleset-group-title">
                                <h3 className="ruleset-metric-title">{text.metric}</h3>
                            </div>
                            <div className="ruleset-group-header-list">
                                <div className="header-row"><span className="title">{text.urgency}</span></div>
                                <div className="header-row"><span className="title">{text.status}</span></div>
                                <div className="header-row"><span className="title">{text.updated_at}</span></div>
                                <div className="header-row actions w-0" />
                            </div>
                        </div>
                        {Array.from({length: rows}).map((_, index) => (
                            <SkeletonRow key={index} isDarkMode={isDarkMode} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListSkeleton
